import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ContentConfig } from '@libs/cms/models';
import { PageViewService } from '@libs/shared/services';
import { CmsOutletComponent } from '../../../cms-outlet/cms-outlet.component';

@Component({
  selector: 'ui-product-category-banner',
  imports: [
    CmsOutletComponent,
  ],
  templateUrl: './product-category-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ProductCategoryBannerComponent {
  public contentId: InputSignal<string | undefined> = input();
  public contentConfig: Signal<ContentConfig | undefined> = toSignal(this.pageViewService.getContentConfig());
  public customerNumber: Signal<string | undefined> = computed(() => this.contentConfig()?.customerNumber);
  public constructor(private readonly pageViewService: PageViewService) {}
}
